"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAEArtNrGenerator = void 0;
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
/**
 * The `DefaultAEArtNrGenerator` provides information to create the `AeArtNrModel` for unknown Kette systems.
 */
class DefaultAEArtNrGenerator {
    generateAEArtNr(artNr, { material, color }) {
        const separator = echain_shared_i18n_1.LocaleService.getArtNrSeparator();
        // black (0) should not be appended. [EKE-461]
        if (color && +color !== 0) {
            artNr = artNr + separator + color;
        }
        if (material) {
            artNr = artNr + separator + material;
        }
        return artNr;
    }
}
exports.DefaultAEArtNrGenerator = DefaultAEArtNrGenerator;
//# sourceMappingURL=DefaultAEArtNrGenerator.js.map